import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Send } from 'lucide-react';
export function HeroSection() {
  return <section className="relative h-screen w-full overflow-hidden flex items-center justify-center bg-dark-900" data-id="element-196">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-dark-800 via-dark-900 to-black opacity-80 z-0" data-id="element-197"></div>

      {/* Gold Particles / Abstract Background */}
      <div className="absolute inset-0 opacity-20 z-0" data-id="element-198">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gold-500/20 rounded-full blur-[100px] animate-pulse" data-id="element-199"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-gold-600/20 rounded-full blur-[80px] animate-pulse delay-1000" data-id="element-200"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-202">
          <span className="inline-block py-1 px-3 border border-gold-500/30 rounded-full text-gold-500 text-xs tracking-[0.2em] uppercase mb-6 bg-gold-500/5 backdrop-blur-sm" data-id="element-203">
            Premium Companion Service
          </span>
          <h1 className="text-5xl md:text-7xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-204">
            邂逅优雅，
            <br className="md:hidden" data-id="element-205" />
            尽在 <span className="text-gradient-gold" data-id="element-206">IsYou</span>
          </h1>
          <p className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto mb-12 font-light" data-id="element-207">
            新加坡领先的高端伴游服务平台，汇集全球优质伴游女郎。
            <br data-id="element-208" />
            真人核验，安全可靠，为您提供尊贵体验。
          </p>
        </motion.div>

        {/* CTA Buttons */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 max-w-xl mx-auto" data-id="element-209">
          <a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto group flex items-center justify-center gap-3 bg-gold-500 hover:bg-gold-400 text-dark-900 font-bold py-4 px-8 rounded transition-all duration-300 text-base tracking-wide" data-id="element-210">
            <ExternalLink className="w-5 h-5" data-id="element-211" />
            新加坡春风阁
          </a>
          <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto group flex items-center justify-center gap-3 border border-gold-500 text-gold-500 hover:bg-gold-500 hover:text-dark-900 font-bold py-4 px-8 rounded transition-all duration-300 text-base tracking-wide" data-id="element-212">
            <Send className="w-5 h-5" data-id="element-213" />
            电报频道 / Telegram Channel
          </a>
        </motion.div>

        {/* Stats */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mt-12 flex flex-wrap justify-center gap-6 md:gap-12 text-sm text-gray-400" data-id="element-214">
          <div className="flex items-center" data-id="element-215">
            <span className="w-1.5 h-1.5 bg-gold-500 rounded-full mr-2" data-id="element-216"></span>
            500+ 优质伴游
          </div>
          <div className="flex items-center" data-id="element-217">
            <span className="w-1.5 h-1.5 bg-gold-500 rounded-full mr-2" data-id="element-218"></span>
            100% 真人核验
          </div>
          <div className="flex items-center" data-id="element-219">
            <span className="w-1.5 h-1.5 bg-gold-500 rounded-full mr-2" data-id="element-220"></span>
            24/7 在线客服
          </div>
          <div className="flex items-center" data-id="element-221">
            <span className="w-1.5 h-1.5 bg-gold-500 rounded-full mr-2" data-id="element-222"></span>
            见面满意付款
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center" data-id="element-223">
        <span className="text-[10px] text-gold-500 uppercase tracking-widest mb-2" data-id="element-224">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-gold-500 to-transparent" data-id="element-225"></div>
      </motion.div>
    </section>;
}